module.exports = __webpack_public_path__ + "img/accounting.d1fb9930.svg";